module.exports = window["braintree"]["googlePayment"];